import { ApolloClient, gql } from '@apollo/client/core';
import * as VPConfig from '../api/VPConfig';
import { Query } from '../generated/graphql';
import { ACCOUNT_AGNOSTIC } from './accountContext';

const GET_CONFIG_QUERY = gql`
  query GetConfig {
    vpConfig {
      cognito {
        region
        clientId
      }
    }
  }
`;

export const getConfig = async (client: ApolloClient<Query>): Promise<VPConfig.VPConfig> => {
  const { data } = await client.query({
    query: GET_CONFIG_QUERY,
    fetchPolicy: 'network-only',
    // Account-agnostic: the Cognito pool this reads is what the operator needs in order to log in
    // at all, so it is fetched before there is a session, let alone an account.
    context: ACCOUNT_AGNOSTIC,
  });

  return VPConfig.fromGql(data.vpConfig);
};
